export const POLICY_ALLOWED_EXTENSIONS = ['csv', 'xlsx', 'json', 'txt', 'pdf', 'docx'] as const;

export const POLICY_ACCEPT_STRING = POLICY_ALLOWED_EXTENSIONS.map((ext) => `.${ext}`).join(',');

export const POLICY_ALLOWED_FORMAT_LABEL = POLICY_ALLOWED_EXTENSIONS.map((ext) => ext.toUpperCase()).join(', ');

export const isPolicyFileAllowed = (fileName?: string): boolean => {
  if (!fileName) {
    return false;
  }

  const extension = fileName.split('.').pop()?.toLowerCase();
  return extension ? POLICY_ALLOWED_EXTENSIONS.includes(extension as typeof POLICY_ALLOWED_EXTENSIONS[number]) : false;
};
